import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-hospital-cash-support-doc',
    templateUrl: './hospital-cash-support-doc.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HospitalCashSupportDocComponent {
  public showAddDoc = false;
}
